<template>
  <layout-centered>
    <div class="text-center space-y-6">
      <div class="text-color-text-300 text-5xl font-semibold leading-[42px]">{{ statusMessage }}</div>
      <div class="text-color-gray-opacity-55 text-2xl font-semibold">{{ cause }}</div>
      <div>
        <button-default class="bg-color-bg-100! border-[1px] border-solid border-color-gray-200 text-color-primary-2! px-7 text-sm font-semibold hover:bg-color-gray-200!" @click="goTo">{{ t('backHome') }}</button-default>
      </div>
    </div>
  </layout-centered>
</template>

<script setup>
import LayoutCentered from '../templates/LayoutCentered.vue';
import ButtonDefault from '../atoms/ButtonDefault.vue';
import { getUser } from '../composables/useAuth';
import { useRouter } from 'vue-router';
import { LANDING_PAGE } from '../composables/useConstants';
import { useI18n } from 'vue-i18n';

defineProps({
  statusMessage: {
    type: String,
    default: 'Page not found'
  },
  cause: {
    type: String,
    default: 'The page you are trying to access does not exist'
  }
});

const { t } = useI18n();

const router = useRouter();
const user = getUser();

function goTo() {
  // eslint-disable-next-line no-undef
  clearError();

  if (user.value) {
    router.push('/');
  } else {
    window.location.href = LANDING_PAGE;
  }
}
</script>
